import React, { useState } from "react";
import { uri } from "../../../../../help/Api";
import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { insh, sto } from "../../../../../Context/InshData";
import BackdropScI from "../../../../../services/BackdropScI";
import IReceiptVoucher from "./IReceiptVoucher";

import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { accountsURL } from '../../../../../api/IReceipt';
import { useEffect } from "react";
import { Dialog } from "@material-ui/core";
import dataF from "../../../../../Server/dataF.json"

function getReFormatingAccount(data){

    const newData = data.map((row, i)=> {
            return {id: row.id,
                 name:row.symbol,
                 code: row.barcode,
                } 
        })
    return newData
}

export default  function ReceiptVoucherDialog(props){
    const {open, onClose,onSave ,invData,db_name } = props;

    const [branch, setBranch] = useState({ id: -1, name: "الكل" });
    const tb = {
      wait: true,
      Branch: true,
      stor: { ...sto, branchi:branch.id == -1 ? invData.branch : branch.id },
      parms: { 
          branch:branch.id == -1 ? invData.branch : branch.id ,
          iempid: sto.empi,
          db_name:db_name,
       },
  
    };
  
    const { object: AutoOptionsB, fetching: fetchAll } = useFetchObjectByPost(
      uri + "GetD",
      tb,
      [branch]
    );
     const requestData ={
      /*other:true,*/ // out
      wait:true,
      other:true,
      Users:true,
      Stocks:true, // Error // out
      Banks:true,
      AccountBooks: true,
      // salesmen:true,
      costcenters:true,
      // Employees:true,
      CheckStatus:true,
      PermissionsElemnts:true,
      /*params*/ // out
      parms:{
        ibranchid:branch.id == -1 ? invData.branch : branch.id , 
        iempid: sto.empi,
        iuserid: sto.idi, 
        icustmtype: 1,
        scurrenciestype: 'I',
        branch:branch.id == -1 ? invData.branch : branch.id ,
        tname:"sandqd",
        iformid: dataF[68].id,
        db_name:db_name,
      },
      autos:{
        AccountBooks: true,
        Users:true,
        Safes:true,
        Stocks:true,
        Banks:true,
        // Employees:true,
      //   salesmens:true,
        costcenters: true,
        CheckStatus: true,
      }
    }
  


    const url = uri+'Res';

    const {object:AutoOptions, fetching: fetchinData, fetch:fetchURL} =  
    useFetchObjectByPost(url, requestData, [branch]);
    const {data, fetching, fetchURL: fetchURL1} = useFetchURL({...{
      url: accountsURL,
      mapFunction: getReFormatingAccount,
    }})
    useEffect(()=>{
      console.log('the data is', data);
    })
      if(fetchinData || !data || fetching || !AutoOptions.Stocks ||!AutoOptionsB?.Branches)
        return <BackdropScI />


    return (
        <Dialog fullScreen open={open} onClose={onClose}>
         <IReceiptVoucher
        {...{
            AutoOptions: AutoOptions?.Users? {...AutoOptions, Customers: data}: [],
            fetchURL,
            prmis: AutoOptions?.permisElm?? insh.permiElm, 
            ...props,
            invData,
            isDialog: false,
            isDialogData: true,
            AutoOptionsB: AutoOptionsB?.Branches? AutoOptionsB: [],
            branch,
            setBranch,
            db_name
        }}/>
        </Dialog> 

    )
}




   